export default "__VITE_ASSET__CFDPfAGP__"